var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomCta',{staticClass:"go-back-button",attrs:{"type":"icon"},on:{"click":_vm.goBackClick}},[_c(("IconGoBack" + (_vm.color.charAt(0).toUpperCase() + _vm.color.slice(1))),{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }